export enum UOMId {
  C62 = 'C62',
  KGM = 'KGM',
  GRM = 'GRM',
  LBR = 'LBR',
}
